'use client';

import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import isOuinexMarketDomain from '@/utils/isOuinexMarketDomain';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import * as React from 'react';
import { useState } from 'react';

export default function NavigationLink({ href, prefetch = false, scroll = true, ...props }) {
  const [_prefetch, set_prefetch] = useState(prefetch);
  const { locale } = useParams();

  const rel = props.target === '_blank' ? 'noopener noreferrer nofollow' : undefined;

  let _href = `/${locale}${href || '#'}`;
  if (href && !href?.startsWith('/')) {
    _href = href;
  }

  // this will be removed later
  if (isOuinexMarketDomain(_href)) {
    const { rel, href, children, ...rest } = props;
    return (
      <button
        className={cn('cursor-pointer', buttonVariants({ variant: 'link' }), rest?.className)}
        data-url={_href}
        {...rest}
      >
        {children}
      </button>
    );
  }

  return (
    <Link
      {...props}
      href={_href}
      prefetch={_prefetch}
      rel={rel}
      scroll={scroll}
      onMouseMove={() => set_prefetch(true)}
      onTouchStart={() => set_prefetch(true)}
    />
  );
}
